import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import UserPermission from 'lib/enums/UserPermission';
import useUserPermissions from 'lib/hooks/useUserPermissions';

function useViewGMV() {
  const location = useLocation();
  const hasUserPermissions = useUserPermissions();
  const viewGMVPermissions = useMemo(
    () => hasUserPermissions([UserPermission.UPB_VIEW]),
    [hasUserPermissions],
  );
  const pathsToIgnore = location.pathname.includes('sales-viewer');
  const viewGMV = viewGMVPermissions && !pathsToIgnore;

  return viewGMV;
}

export default useViewGMV;
